import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import { useEffect } from "react";
import { ROLES } from "../../constants";
import {
  ActiveMenuIcon,
  activeTokensIcon,
  GuildHubIcon,
  GuildHubIconActive,
  Logo,
  ProfileIcon,
  ProfileIconActive,
  tokensIcon,
} from "../../assets";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useTypedSelector } from "../../hooks/useTypedSelector";
import { tokens } from "../../theme";
import { useTheme } from "@mui/material";
import { getKeyForYieldClaim } from "../../utils/wallet/apiHelpers";
import { useWeb3React } from "@web3-react/core";

const drawerWidth = 240;

export default function PermanentDrawerLeft() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { connectedAccount } = useTypedSelector((state) => state.apiReducer);
  const [selected, setSelected] = useState("Overview");
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { account } = useWeb3React();

  const [menuItems, setMenuItems] = useState([
    // {
    //   title: "Overview",
    //   to: "/",
    //   // icon: <PaymentOutlinedIcon />,
    //   icon: <img src={OverviewIcon} alt="overview" />,
    //   activeIcon: <img src={OverviewIconActive} alt="overview" />,
    //   selected: false,
    //   visibility: "visible",
    // },
    {
      title: "My Nfts",
      to: "/",
      icon: <img src={ProfileIcon} alt="overview" />,
      activeIcon: <img src={ProfileIconActive} alt="overview" />,
      selected: false,
      visibility: "visible",
    },
    {
      title: "Guild Hub",
      to: "/scholar-details",
      icon: <img src={GuildHubIcon} alt="overview" />,
      activeIcon: <img src={GuildHubIconActive} alt="overview" />,
      selected: false,
      visibility: connectedAccount.role === ROLES.GUILD ? "visible" : "hidden",
    },
    {
      title: "Tokens",
      to: "/tokens",
      icon: <img src={tokensIcon} alt="overview" />,
      activeIcon: <img src={activeTokensIcon} alt="overview" />,
      selected: false,
      visibility: "visible",
    },
  ]);

  const setSelection = (title) => {
    let updatedMenuItems = menuItems.map((menu) => {
      if (menu.title === title) {
        return {
          ...menu,
          selected: true,
        };
      } else {
        return {
          ...menu,
          selected: false,
        };
      }
    });

    setMenuItems(updatedMenuItems);
  };

  useEffect(() => {
    let updatedMenuItems = [
      ...menuItems.map((menu) => {
        if (menu.to === "/scholar-details") {
          return {
            ...menu,
            visibility:
              connectedAccount.role === ROLES.GUILD ? "visible" : "hidden",
          };
        } else {
          return menu;
        }
      }),
    ];
    setMenuItems(updatedMenuItems);
  }, [connectedAccount]);

  useEffect(() => {
    let updatedMenuItems = menuItems.map((menu) => {
      if (menu.to === pathname) {
        return {
          ...menu,
          selected: true,
        };
      } else {
        return {
          ...menu,
          selected: false,
        };
      }
    });

    setMenuItems(updatedMenuItems);
  }, [pathname]);

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
          },
        }}
        variant="permanent"
        anchor="left"
      >
        <Toolbar>
          <img
            src={Logo}
            alt="main logo"
            onClick={() => getKeyForYieldClaim(account)}
          />
        </Toolbar>
        {/* <Divider /> */}
        <List>
          {menuItems.map((menu, index) => {
            if (menu.visibility === "visible") {
              return (
                <ListItem key={menu.title} disablePadding>
                  <img
                    src={ActiveMenuIcon}
                    alt={"active menu "}
                    style={{
                      visibility: menu.selected ? menu.visibility : "hidden",
                    }}
                  />

                  <ListItemButton
                    component={Link}
                    to={menu.to}
                    onClick={() => {
                      //   navigate(menu.to);
                      setSelection(menu.title);
                    }}
                    sx={{
                      backgroundColor: menu.selected
                        ? colors.primary[900]
                        : colors.whiteAccent[900],
                      borderRadius: "5px",
                      marginLeft: "5px",
                      marginRight: "5px",
                    }}
                  >
                    <ListItemIcon>
                      {menu.selected ? menu.activeIcon : menu.icon}
                    </ListItemIcon>
                    <ListItemText
                      primary={menu.title}
                      sx={{ color: colors.black[500] }}
                    />
                  </ListItemButton>
                </ListItem>
              );
            }
          })}
        </List>
      </Drawer>
    </Box>
  );
}
